export { default } from './ImageLeafParagraph';
